import { render, staticRenderFns } from "./ManTag.vue?vue&type=template&id=553bb7f2&scoped=true"
import script from "./ManTag.vue?vue&type=script&lang=js"
export * from "./ManTag.vue?vue&type=script&lang=js"
import style0 from "./ManTag.vue?vue&type=style&index=0&id=553bb7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553bb7f2",
  null
  
)

export default component.exports